import { Key, pathToRegexp } from 'path-to-regexp';

export type RouteMatch = {
  key: string;
  pattern: string;
  params: Record<string, string>;
};

/**
 * Match a pathname against route patterns with dynamic segments
 * Returns null if no match, or RouteMatch if matched
 */
export const matchRoute = (
  pathname: string,
  routes: Record<string, string>
): RouteMatch | null => {
  const sortedRoutes = Object.entries(routes)
    .filter(([key]) => key !== 'NOT_FOUND')
    .sort((a, b) => b[1].length - a[1].length);

  return sortedRoutes.reduce<RouteMatch | null>((acc, [key, pattern]) => {
    if (acc !== null) return acc; // Already found

    const keys: Key[] = [];
    // Pass keys inside options object
    const result = pathToRegexp(pattern, { keys });
    const match = result.regexp.exec(pathname);

    if (!match) return null;

    const params: Record<string, string> = {};
    keys.forEach((keyObj, i) => {
      params[keyObj.name] = match[i + 1];
    });

    return {
      key,
      pattern,
      params
    };
  }, null);
};
